export const getDeviceInfo = () => {
  const userAgent = navigator.userAgent

  const isMobile = /android|iphone|ipad|mobile/i.test(userAgent)

  const getOS = () => {
    if (/windows/i.test(userAgent)) {
      return 'Windows'
    }

    if (/mac os/i.test(userAgent)) {
      return 'MacOS'
    }

    if (/linux/i.test(userAgent)) {
      return 'Linux'
    }

    if (/android/i.test(userAgent)) {
      return 'Android'
    }

    if (/ios|iphone|ipad/i.test(userAgent)) {
      return 'iOS'
    }

    return 'Unknown'
  }

  const getBrowser = () => {
    if (/edg/i.test(userAgent)) {
      return 'Edge'
    }

    if (/chrome|crios/i.test(userAgent)) {
      return 'Chrome'
    }

    if (/firefox|fxios/i.test(userAgent)) {
      return 'Firefox'
    }

    if (/safari/i.test(userAgent) && !/chrome|crios/i.test(userAgent)) {
      return 'Safari'
    }

    return 'Other'
  }

  return {
    deviceType: isMobile ? 'Mobile' : 'Desktop',
    os: getOS(),
    browser: getBrowser(),
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
  }
}
